import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_VENDOR_V2, UPDATE_VENDOR_V2_SUCCESS, UPDATE_VENDOR_V2_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateVendorV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/benefit-type/airport-transfer/${payload?.data?.id}`,
      method: 'PUT',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: UPDATE_VENDOR_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: UPDATE_VENDOR_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_VENDOR_V2_ERROR, payload: error });
  }
}

export function* watchupdateVendorV2() {
  yield takeEvery(UPDATE_VENDOR_V2, updateVendorV2);
}

function* updateVendorV2Saga() {
  yield all([fork(watchupdateVendorV2)]);
}

export default updateVendorV2Saga;
